<template>
  <div class="row">
    <div class="col-md-12 card">
      <div class="card-header bottom_margin_30">
        <div v-if="(g_examination) && (g_examination.status > 11) && (g_examination.status < 20)" class="category">
          <el-tabs class="col-md-12" type="border-card" @tab-click="show_tab_click">
            <el-tab-pane label="Global setup:">
              <div class="row">
                <div class="col-md-5 ml-auto mr-auto bg_gray">
                  <div class="block bottom_margin_30">
                    <span class="demonstration">Transcript system:</span><br />
                      <el-switch
                        v-model="er_switch"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        active-text="RefSeq"
                        inactive-text="Ensembl "
                        >
                      </el-switch>
                  </div>

                  <div class="block bottom_margin_30">
                    <span class="demonstration">List All Variants Of Examination (without filter):</span><br />
                      <el-tooltip content="My description ..." placement="top" effect="light">  
                        <p-button type="info mr-auto ml-auto" block @click.native="show_all_vars">
                          Show All Variants
                        </p-button>
                      </el-tooltip>
                  </div>
                </div>

                <div class="col-md-5 ml-auto mr-auto bg_gray">
                  <div class="block bottom_margin_30">
                    <span class="demonstration">Page size for loading data</span>
                    <el-slider
                      v-model="slider_value"
                      :step="100"
                      :max=1000
                      show-stops
                      show-tooltip
                      ></el-slider>
                  </div>

                  <div class="block margin_top_20">
                    <span class="demonstration">Page number (offset)</span><br />
                    <el-input-number 
                      v-model="var_page" 
                      :min="1" 
                      :max="1000"
                      controls-position="right"
                      ></el-input-number>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="Favourite Filters:">
              <div class="col-md-12 bg_gray top_margin_10 bottom_margin_10">
                <el-button-group>
                  <el-button type="primary" icon="el-icon-user-solid" @click.native="ff_type(0)"></el-button>
                  <el-button type="primary" icon="el-icon-office-building" @click.native="ff_type(1)"></el-button>
                  <el-button type="primary" icon="el-icon-rank" @click.native="ff_type(2)"></el-button>
                </el-button-group>
              </div>

              <div class="col-md-12 bg_gray">
                <el-table class=""
                          ref="f_filters"
                          :data="f_filters_data"
                          border
                          highlight-current-row
                          @current-change="handleCurrentChange_ff"
                          style="width: 100%"
                          size="medium"
                          >
                  <el-table-column v-for="column in tableColumns_ff"
                                  :key="column.label"
                                  :min-width="column.minWidth"
                                  :prop="column.prop"
                                  :label="column.label"
                                  :align="column.align"
                                  :sortable="column.sortable"
                                  >
                  </el-table-column>

                  <el-table-column min-width="150"
                                  header-align="right"
                                  label="Actions">
                    <div slot-scope="{row}" class="text-right">
                      <el-tooltip content="Info"
                                  :open-delay="300"
                                  placement="top">
                        <p-button type="info" size="sm" icon>
                          <i class="nc-icon nc-alert-circle-i"></i>
                        </p-button>
                      </el-tooltip>


                      <el-tooltip content="Settings"
                                  :open-delay="300"
                                  placement="top">
                        <p-button type="success" size="sm" icon>
                          <i class="nc-icon nc-settings"></i>
                        </p-button>
                      </el-tooltip>

                      <el-tooltip content="Delete"
                                  :open-delay="300"
                                  placement="top">
                        <p-button type="danger" size="sm" icon>
                          <i class="nc-icon nc-simple-delete"></i>
                        </p-button>
                      </el-tooltip>

                    </div>
                  </el-table-column>



                </el-table>
              </div>

              <div class="col-md-12 bg_gray top_margin_30">
                <form class="form-horizontal">
                  <h4 slot="header" class="card-title">
                    Save actual custom filter setting as new favourite filter
                  </h4>
                  <div class="row">
                    <label class="col-md-3 col-form-label">Name</label>
                    <div class="col-md-9">
                      <fg-input v-model="filter_name" placeholder=""></fg-input>
                    </div>

                    <label class="col-md-3 col-form-label">Description</label>
                    <div class="col-md-9">
                      <fg-input v-model="filter_description" placeholder=""></fg-input>
                    </div>

                    <label class="col-md-3 col-form-label"></label>
                    <div class="col-md-9">
                      <fg-input placeholder="">
                        <p-checkbox>Share filter</p-checkbox>
                      </fg-input>
                    </div>
                  </div>

                  <div slot="footer" class="row">
                    <div class="col-md-6 mr-auto ml-auto">
                      <el-tooltip content="My description ..." placement="top" effect="light">
                        <p-button type="info" block @click.native="a_filter_save">
                          SAVE
                        </p-button>
                      </el-tooltip>
                    </div>
                  </div>
                </form>
              </div>

            </el-tab-pane>   

            <el-tab-pane label="Diagnoses:">
                    <div class="row bottom_margin_10 bg_gray">
                      <div class="col-sm-12">
                        <div class="col-sm-6">
                          <!-- <el-select
                            class="select-info"
                            v-model="pagination_hpo.perPage"
                            placeholder="Per page">
                            <el-option
                              class="select-info"
                              v-for="item in pagination_hpo.perPageOptions"
                              :key="item"
                              :label="item"
                              :value="item">
                            </el-option>
                          </el-select> -->

                                <el-input
                                  v-model="searchQuery_hpo"
                                  size=""
                                  class="top_margin_10"
                                  placeholder="Type to search HPO" />
                        </div>
                        <div class="col-sm-6">
                          <div class="pull-right">

                          </div>
                        </div>
                        <div class="col-sm-12 mt-2">
                          <el-table class=""
                                    ref="hpo"
                                    :data="hpo_data.filter(data => !searchQuery_hpo || data.hpo_term_name.toLowerCase().includes(searchQuery_hpo.toLowerCase()))"
                                    border
                                    highlight-current-row
                                    @current-change="handleCurrentChange_hpo"
                                    style="width: 100%"
                                    size="medium"
                                    >
                            <el-table-column
                              prop="hpo_term_name"
                              label="HPO"
                              min-width="180"
                              >
                            
                              <template slot-scope="scope">
                                <span>{{ scope.row.hpo_term_name }}</span>
                              </template>
                            </el-table-column>
                            
                            <el-table-column
                              label="Gene Names"
                              min-width="400">
                              <template slot-scope="scope">
                                    <el-tag v-for="one in scope.row.genelist" size="small" type="primary" class="gene_blue" @click.native="show_click(one)">{{ one }}</el-tag>
                              </template>
                            </el-table-column>
    
                          </el-table>
                        </div>
                        <div class="col-sm-4 pagination-info">
                          <p class="category">Showing {{from_hpo + 1}} to {{to_hpo}} of {{total_hpo}} entries</p>
                        </div>
                        <div class="col-sm-12">
                          <p-pagination class="pull-right"
                                        v-model="pagination_hpo.currentPage"
                                        :per-page="pagination_hpo.perPage"
                                        :total="pagination_hpo.total"
                                        :pager-count=5

                                        >
                          </p-pagination>
                        </div>
                      </div>



                    </div>
            </el-tab-pane>

            <el-tab-pane label="Custom Filter:">
              <div class="col-md-12 bg_gray">
                  <form class="form-horizontal">
                    <h4 slot="header" class="card-title">
                      
                    </h4>

                    <div class="row bottom_margin_10">
                      <label class="col-md-2 col-form-label top_margin_10">READ DEPTH</label>
                      <div class="col-md-2 top_margin_10">
                        <el-input-number placeholder="" controls-position="right" v-model="cufi_read_depth" size="small"></el-input-number>
                      </div>

                      <label class="col-md-1 col-form-label top_margin_10">FREQ<BR/>VCF</label>
                      <div class="col-md-3 block top_margin_10 bottom_margin_10">
                            <el-slider
                              v-model="cufi_freq_vcf"
                              range
                              :marks="slider_marks"
                              :step="1"
                              :max="100"
                              >
                            </el-slider>
                      </div>

                      <label class="col-md-2 col-form-label top_margin_10">GENOTYPE</label>
                      <div class="col-md-2 top_margin_10">
                        <el-select v-model="cufi_genotype" placeholder="" size="small" multiple>
                          <el-option
                            v-for="item in l_gt"
                            :key="item"
                            :label="item"
                            :value="item">
                          </el-option>
                        </el-select>                      
                      </div>
                    </div>

                    <div class="row bottom_margin_10">
                      <label class="col-md-1 col-form-label">Freq<BR/>project</label>
                      <div class="col-md-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_freq_project"
                              range
                              :marks="slider_marks"
                              :step="2"
                              :max="100">
                            </el-slider>
                      </div>

                      <label class="col-md-1 col-form-label">Freq<BR/>subject</label>
                      <div class="col-md-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_freq_subject"
                              range
                              :marks="slider_marks"
                              :step="2"
                              :max="100">
                            </el-slider>
                      </div>

                      <label class="col-md-1 col-form-label">Freq<BR/>global</label>
                      <div class="col-md-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_freq_global"
                              range
                              :marks="slider_marks"
                              :step="2"
                              :max="100">
                            </el-slider>
                      </div>
                    </div>

                    <div class="row bottom_margin_10">
                      <label class="col-md-1 col-form-label">IMPACT</label>
                      <div class="col-md-5">
                        <fg-input>
                          <el-select class="select-primary"
                                    size="medium"
                                    multiple
                                    filterable
                                    placeholder=""
                                    v-model="cufi_impacts">
                            <el-option v-for="one in l_impacts"
                                      class="select-primary"
                                      :value="one"
                                      :label="one"
                                      :key="one">
                            </el-option>
                          </el-select>
                        </fg-input>
                      </div>

                      <label class="col-md-1 col-form-label">CON<br/>SEQUENCE</label>
                      <div class="col-md-5">
                        <fg-input>
                          <el-select class="select-primary"
                                    size="medium"
                                    multiple
                                    filterable
                                    :filter-method="select_filter"
                                    placeholder=""
                                    v-model="cufi_consequences">
                            <el-option v-for="one in l_consequences"
                                      class="select-primary"
                                      :value="one"
                                      :label="one"
                                      :key="one">
                            </el-option>
                          </el-select>
                        </fg-input>
                      </div>
                    </div>

                    <div class="row bottom_margin_10">
                      <label class="col-md-1 col-form-label">CLINVAR</label>
                      <div class="col-md-5">
                        <fg-input>
                          <el-select class="select-warning"
                                    size="medium"
                                    multiple
                                    filterable
                                    :filter-method="select_filter"
                                    placeholder=""
                                    v-model="cufi_clinvar">
                            <el-option v-for="one in l_clinvars"
                                      class="select-warning"
                                      :value="one"
                                      :label="one"
                                      :key="one">
                            </el-option>
                          </el-select>
                        </fg-input>
                      </div>

                      <label class="col-md-1 col-form-label">CLINVAR DN</label>
                      <div class="col-md-5">
                        <fg-input>
                          <el-select class="select-danger"
                                    size="medium"
                                    multiple
                                    filterable
                                    :filter-method="select_filter"
                                    placeholder=""
                                    v-model="cufi_clinvar_dn">
                            <el-option v-for="one in l_clinvar_dns"
                                      class="select-danger"
                                      :value="one"
                                      :label="one"
                                      :key="one">
                            </el-option>
                          </el-select>
                        </fg-input>
                      </div>
                    </div>

                    <div class="row bottom_margin_10">
                      <label class="col-1 col-form-label">Interpret<BR/>Subject</label>
                      <div class="col-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_interpret_subject"
                              range
                              :marks="slider_marks_5"
                              :step="1"
                              :min="1"
                              :max="5">
                            </el-slider>
                      </div>

                      <label class="col-1 col-form-label">Interpret<BR/>Subject<BR/>empty</label>
                      <div class="col-1 block top_margin_10">
                        <el-switch
                          v-model="cufi_wois_switch"
                          >
                        </el-switch>
                      </div>

                      <label class="col-1 col-form-label">Interpret<BR/>ALL</label>
                      <div class="col-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_interpret_all"
                              range
                              :marks="slider_marks_5"
                              :step="1"
                              :min="1"
                              :max="5">
                            </el-slider>
                      </div>

                      <label class="col-1 col-form-label">Interpret<BR/>ALL<BR/>empty</label>
                      <div class="col-1 block top_margin_10">
                        <el-switch
                          v-model="cufi_woia_switch"
                          >
                        </el-switch>
                      </div>
                    </div>

                    <div class="row bottom_margin_10">
                      <label class="col-md-1 col-form-label">GNOMAD AF</label>
                      <div class="col-md-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_gnomad_af"
                              range
                              :marks="slider_marks_10"
                              :step="0.01"
                              :min="0"
                              :max="1">
                            </el-slider>
                      </div>

                      <label class="col-md-1 col-form-label">GNOMAD AF NFE</label>
                      <div class="col-md-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_gnomad_af_nfe"
                              range
                              :marks="slider_marks_10"
                              :step="0.01"
                              :min="0"
                              :max="1">
                            </el-slider>
                      </div>

                      <label class="col-md-1 col-form-label">EXAC AF NFE</label>
                      <div class="col-md-3 block bottom_margin_30">
                            <el-slider
                              v-model="cufi_exac_af_nfe"
                              range
                              :marks="slider_marks_10"
                              :step="0.01"
                              :min="0"
                              :max="1">
                            </el-slider>
                      </div>
                    </div>

                    <div class="row bottom_margin_10">
                      <label class="col-md-1 col-form-label">GENE</label>
                      <div class="col-md-10">
                        <fg-input>
                          <el-select class="select-info"
                                    size="medium"
                                    multiple
                                    filterable
                                    :filter-method="select_filter_gene"
                                    placeholder=""
                                    v-model="cufi_genes">
                            <el-option v-for="one in g_gene"
                                      class="select-info"
                                      :value="one"
                                      :label="one"
                                      :key="one">
                            </el-option>
                          </el-select>
                        </fg-input>
                      </div>
                      <div class="col-md-1">
                        <el-button type="danger" size="mini" icon="el-icon-delete" placeholder="Delete all genes from input ..." @click.native="cufi_genes_del()"></el-button>
                      </div>

                    </div>

                    <div slot="footer" class="row">
                      <div class="col-md-3">
                      </div>
                      <div class="col-md-3">
                        <p-button type="warning mr-auto ml-auto" block @click.native="reset_filter">
                          Reset filter
                        </p-button>
                      </div>
                      <div class="col-md-3">
                        <p-button type="info mr-auto ml-auto" block @click.native="show_vars">
                          Show variants
                        </p-button>
                      </div>
                      <div class="col-md-3">
                      </div>
                    </div>
                  </form>
              </div> <!--  end col-md-12  -->




            </el-tab-pane>
          </el-tabs>
        </div>

        <div v-if="(g_examination) && (g_examination.status > 20) && (g_examination.status < 30)" class="category">
          <el-tabs class="col-md-12" type="border-card" @tab-click="show_tab_click">
            <el-tab-pane label="Metadata:">
              <div class="row">
                <div class="col-md-5 ml-auto mr-auto bg_gray">

                </div>

                <div class="col-md-5 ml-auto mr-auto bg_gray">

                </div>
              </div>
            </el-tab-pane>
            
            <el-tab-pane label="Report:">
              <div class="col-md-12 bg_gray top_margin_10 bottom_margin_10">
                <el-button-group>
                  <el-button type="primary" icon="el-icon-user-solid" @click.native="ff_type(0)"></el-button>
                  <el-button type="primary" icon="el-icon-office-building" @click.native="ff_type(1)"></el-button>
                  <el-button type="primary" icon="el-icon-rank" @click.native="ff_type(2)"></el-button>
                </el-button-group>
              </div>

            </el-tab-pane>   

          </el-tabs>
        </div>


      </div>

      <div v-if="(g_examination) && (g_examination.status > 11)" class="card-body row">
        <div class="col-sm-6">
          <el-select
            class="select-default"
            v-model="pagination_v.perPage"
            placeholder="Per page">
            <el-option
              class="select-default"
              v-for="item in pagination_v.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
              >
            </el-option>
          </el-select>
        </div>

        <div class="col-sm-6">
          <div class="pull-right">
            <el-select 
              class="select-default"
              v-model="var_order" 
              clearable 
              placeholder="Select item for ordering"
              @change="order_select_change"
              >
              <el-option
                v-for="item in var_order_options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="col-sm-12 mt-2">
          <el-table 
                    ref="vars"
                    :data="vars_data"
                    row-key="id_ant"
                    border
                    highlight-current-row
                    @current-change="handleCurrentChange_v"
                    style="width: 100%"
                    size="mini"
                    >
            <el-table-column type="expand">
              <template slot-scope="props">
                    <el-tabs type="border-card">
                      <el-tab-pane label="Main">
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_1"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_1 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_2"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_2 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_13"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_13 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_397"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_397 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_14"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_14 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_15"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_15 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_16"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_16 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_17"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_17 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_19"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_19 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_20"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_20 }}</div></el-col>
                        </el-row>        
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_22"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_22 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_24"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_24 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_5"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_5 }}</div></el-col>
                        </el-row>              
                      </el-tab-pane>
                      <el-tab-pane label="ClinVar">
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_451"]}}:</div></el-col>
                          <el-col :span="3">
                            <el-popover
                              placement="top"
                              :title="d_a_cols['a_451']"
                              width="600"
                              trigger="click"
                              >
                              <div v-html="popover_items(props.row.a_451)">
                              </div>                              
                              <el-button v-if="props.row.a_451" slot="reference" size="mini">{{ (props.row.a_451).split(',')[0].substr(0,27) }}, ... </el-button>
                            </el-popover>
                          </el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_455"]}}:</div></el-col>
                          <el-col :span="3">
                            <el-popover
                              placement="top"
                              :title="d_a_cols['a_455']"
                              width="600"
                              trigger="click"
                              >
                              <div v-html="popover_items(props.row.a_455)">
                              </div>                              
                              <el-button v-if="props.row.a_455" slot="reference" size="mini">{{ (props.row.a_455).split(',')[0].substr(0,27) }}, ... </el-button>
                            </el-popover>
                          </el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_459"]}}:</div></el-col>
                          <el-col :span="3">
                            <el-popover
                              placement="top"
                              :title="d_a_cols['a_459']"
                              width="600"
                              trigger="click"
                              >
                              <div v-html="popover_items(props.row.a_459)">
                              </div>                              
                              <el-button v-if="props.row.a_459" slot="reference" size="mini">{{ (props.row.a_459).split(',')[0].substr(0,27) }}, ... </el-button>
                            </el-popover>
                          </el-col>   
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_452"]}}:</div></el-col>
                          <el-col :span="3">
                            <el-popover
                              placement="top"
                              :title="d_a_cols['a_452']"
                              width="600"
                              trigger="click"
                              >
                              <div v-html="popover_items(props.row.a_452)">
                              </div>                              
                              <el-button v-if="props.row.a_452" slot="reference" size="mini">{{ (props.row.a_452).split(',')[0].substr(0,27) }}, ... </el-button>
                              <el-button v-else slot="reference" size="small"> </el-button>
                            </el-popover>
                          </el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_453"]}}:</div></el-col>
                          <el-col :span="3">
                            <el-popover
                              placement="top"
                              :title="d_a_cols['a_453']"
                              width="600"
                              trigger="click"
                              >
                              <div v-html="popover_items(props.row.a_453)">
                              </div>                              
                              <el-button v-if="props.row.a_453" slot="reference" size="mini">{{ (props.row.a_453).split(',')[0].substr(0,27) }}, ... </el-button>
                            </el-popover>
                          </el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_454"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_454 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_455"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_455 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_456"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_456 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_457"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_457 }}</div></el-col>
                        </el-row>        
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_458"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_458 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_450"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_450 }}</div></el-col>
                        </el-row>       
                      </el-tab-pane>
                      <el-tab-pane label="Frequencies Gnomad Exoms">
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_256"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_256 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_35"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_35 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_41"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_41 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_36"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_36 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_37"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_37 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_38"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_38 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_39"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_39 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_40"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_40 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_42"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_42 }}</div></el-col>
                        </el-row>        
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_43"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_43 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_44"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_44 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_45"]}}:</div></el-col>
                          <el-col :span="3">
                            <el-popover
                              placement="top"
                              :title="d_a_cols['a_45']"
                              width="600"
                              trigger="click"
                              >
                              <div v-html="popover_items(props.row.a_45)">
                              </div>                              
                              <el-button v-if="props.row.a_45" slot="reference" size="mini">{{ (props.row.a_45).split(',')[0].substr(0,27) }}, ... </el-button>
                            </el-popover>
                          </el-col>
                        </el-row>  
                      </el-tab-pane>
                      <el-tab-pane label="Frequencies Gnomad genomes">
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_329"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_329 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_330"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_330 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_353"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_353 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_332"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_332 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_334"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_334 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_336"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_336 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_341"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_341 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_345"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_345 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_349"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_349 }}</div></el-col>
                        </el-row>        
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_357"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_357 }}</div></el-col>
                        </el-row>  
                      </el-tab-pane>
                      <el-tab-pane label="Pathogenicity Scores">
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_77"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_77 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_78"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_78 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_79"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_79 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_215"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_215 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_143"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_143 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_144"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_144 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_169"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_169 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_170"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_170 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_195"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_195 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_193"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_193 }}</div></el-col>
                        </el-row>        
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_210"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_210 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_209"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_209 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_216"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_216 }}</div></el-col>
                        </el-row>
                      </el-tab-pane>
                      <el-tab-pane label="Conservation scores">
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_147"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_147 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_148"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_148 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_407"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_407 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_408"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_408 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_409"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_409 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_410"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_410 }}</div></el-col>
                        </el-row>                    
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_411"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_411 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_412"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_412 }}</div></el-col>
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_475"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_475 }}</div></el-col>
                        </el-row>        
                        <el-row :gutter="5" class="min_height">
                          <el-col :span="2"><div class="grid-content text-right small_label">{{ d_a_cols["a_174"]}}:</div></el-col>
                          <el-col :span="3"><div class="grid-content bg-purple-light">{{ props.row.a_174 }}</div></el-col>
                        </el-row>
                      </el-tab-pane>
                    </el-tabs>
              </template>
            </el-table-column>             

            <el-table-column
              label="Internal Class"
              min-width="70"
              align="center"
              >
              <template v-if="scope.row.ints >= 1" slot-scope="scope">
                    <el-button v-if="scope.row.ints === 1" size="small" type="success" @click.native="x_modal_interpretation(scope.row.id_var, scope.row.ints)">{{ scope.row.ints }}</el-button> 
                    <el-button v-else-if="scope.row.ints === 2" size="small" type="success" @click.native="x_modal_interpretation(scope.row.id_var, scope.row.ints)">{{ scope.row.ints }}</el-button> 
                    <el-button v-else-if="scope.row.ints === 3" size="small" type="info" @click.native="x_modal_interpretation(scope.row.id_var, scope.row.ints)">{{ scope.row.ints }}</el-button> 
                    <el-button v-else-if="scope.row.ints === 4" size="small" type="warning" @click.native="x_modal_interpretation(scope.row.id_var, scope.row.ints)">{{ scope.row.ints }}</el-button> 
                    <el-button v-else-if="scope.row.ints === 5" size="small" type="danger" @click.native="x_modal_interpretation(scope.row.id_var, scope.row.ints)">{{ scope.row.ints }}</el-button> 
                    <el-button v-else size="small" type="info">{{ scope.row.ints }}</el-button> 
              </template>
            </el-table-column>

            <el-table-column
              label="ClinVar"
              min-width="65"
              align="center"
              >
              <template v-if="scope.row.clinvar_value > ''" slot-scope="scope">
                  <a :href="mylink_clinsig(scope.row)" target="_blank"> 
                    <el-tag v-if="scope.row.clinvar_value === 5" type="danger" class="hranaty">{{ scope.row.clinvar_value }}</el-tag> 
                    <el-tag v-else-if="scope.row.clinvar_value === 4" type="warning" class="hranaty">{{ scope.row.clinvar_value }}</el-tag> 
                    <el-tag v-else-if="scope.row.clinvar_value === 3" type="info" class="hranaty">{{ scope.row.clinvar_value }}</el-tag> 
                    <el-tag v-else type="success" class="hranaty">{{ scope.row.clinvar_value }}</el-tag> 
                  </a>
              </template>
            </el-table-column>

            <el-table-column
              label="Symbol"
              min-width="120"
              align="center"
              >
              <template v-if="scope.row.a_4 > ''" slot-scope="scope">
                  <a :href="mylink_symbol(scope.row.a_4)" target="_blank"> <el-tag size="small" type="info">{{ scope.row.a_4 }}</el-tag> </a>
              </template>
            </el-table-column>

            <el-table-column
              label="HGVSc"
              min-width="180"
              align="center"
              >
              <template v-if="scope.row.a_11 > ''" slot-scope="scope">
                  <a :href="mylink_hgvsc(scope.row)" target="_blank"> <el-tag size="small" type="info" effect="plain">{{ scope.row.a_11 }}</el-tag> </a>
              </template>
            </el-table-column>

            <el-table-column
              label="dbSNP"
              min-width="120"
              align="center"
              >
              <template v-if="scope.row.a_462 > ''" slot-scope="scope">
                  <a :href="mylink_dbsnp(scope.row.a_462)" target="_blank"> <el-tag size="small" type="success">{{ scope.row.a_462 }}</el-tag> </a>
              </template>
            </el-table-column>

            <el-table-column v-for="column in tableColumns_v"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              :align="column.align"
                              :sortable="column.sortable"
                              >
            </el-table-column>

            <el-table-column v-for="column in tableColumns_v1"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              :align="column.align"
                              :sortable="column.sortable"
                              >
            </el-table-column>

            <el-table-column
              label="Transcript"
              min-width="140"
              align="center"
              >
              <template v-if="scope.row.a_7 > ''" slot-scope="scope">
                  <a :href="mylink_transcript(scope.row)" target="_blank"> <el-tag size="small" type="info" effect="plain">{{ scope.row.a_7 }}</el-tag> </a>
              </template>
            </el-table-column>

            <el-table-column v-for="column in tableColumns_v2"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              :align="column.align"
                              :sortable="column.sortable"
                              >
            </el-table-column>

            <el-table-column v-for="column in tableColumns_v3"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              :align="column.align"
                              :sortable="column.sortable"
                              >
            </el-table-column>

            <el-table-column
              label="COSMIC"
              min-width="140"
              align="center"
              >
              <template v-if="scope.row.a_445 > ''" slot-scope="scope">
                  <a :href="mylink_cosmic(scope.row)" target="_blank"> <el-tag size="small" type="warning" effect="plain">{{ scope.row.a_445 }}</el-tag> </a>
              </template>
            </el-table-column>

            <el-table-column v-for="column in tableColumns_v3a"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              :align="column.align"
                              :sortable="column.sortable"
                              >
            </el-table-column>

            <el-table-column
              label="POS"
              min-width="120"
              align="center"
              >
              <template slot-scope="scope">
                  <a :href="mylink_pos(scope.row)" target="_blank"> <el-tag size="small" type="danger" effect="plain">{{ scope.row.pos }}</el-tag> </a>
              </template>
            </el-table-column>

            <el-table-column v-for="column in tableColumns_v4"
                              :key="column.label"
                              :min-width="column.minWidth"
                              :prop="column.prop"
                              :label="column.label"
                              :align="column.align"
                              :sortable="column.sortable"
                              >
            </el-table-column>

            <el-table-column
              :min-width="150"
              fixed="right"
              class-name="td-actions"
              label="Actions">
              <template slot-scope="props">
                <el-tooltip content="My description ..." placement="top" effect="light">
                  <p-button type="info" size="sm" icon @click="handle_unavailable( props.$index, props.row, $event)">
                    <i class="fa fa-list"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="My description ..." placement="top" effect="light">
                  <p-button type="warning" size="sm" icon @click="handle_transcripts( props.$index, props.row, $event)">
                    <i class="far fa-list-alt"></i>
                  </p-button>
                </el-tooltip>
                <el-tooltip content="My description ..." placement="top" effect="light">
                  <p-button type="success" size="sm" icon @click="handle_unavailable(props.$index, props.row)">
                    <i class="fa fa-box"></i>
                  </p-button>
                </el-tooltip>
              </template>
            </el-table-column>

          </el-table>
        </div>

        <div class="col-sm-6 pagination-info">
          <p class="category">Showing {{from_v + 1}} to {{to_v}} of {{total_v}} entries</p>
        </div>

        <div class="col-sm-6">
          <p-pagination class="pull-right"
                        v-model="pagination_v.currentPage"
                        :per-page="pagination_v.perPage"
                        :total="pagination_v.total"
                        >
          </p-pagination>
        </div>

      </div>


      <modal :show.sync="modal_interpretation" headerClasses="justify-content-center" :show-close="true">
        <h5 slot="header" class="title title-up"> Change Internal Class:</h5>
        <div class="row">
          <el-tabs class="col-md-12" type="border-card" @tab-click="">
            <el-tab-pane label="Change value">
              <form @submit.prevent="submit_formdata_change_class">
                <div class="row">
                  <div class="col-md-12">
                      <label>Class No.</label>
                      <div class="form-group">
                        <el-select class="select-info"
                                  placeholder="Select value"
                                  v-model="formdata_change_class.class_value">
                          <el-option v-for="one in classes"
                                    class="select-info"
                                    :value="one"
                                    :label="one"
                                    :key="one">
                          </el-option>
                        </el-select>
                      </div>

                      <label>Description</label>
                      <div class="form-group">
                        <textarea type="textarea" class="form-control" placeholder="" v-model="formdata_change_class.description"> </textarea>
                      </div>              
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 mr-auto ml-auto">
                    <button type="submit" class="btn btn-info">Submit</button>
                  </div>
                </div>
              </form>
            </el-tab-pane>

            <el-tab-pane label="History">

            </el-tab-pane>

          </el-tabs>

        </div>

      </modal>


      <modal :show.sync="modal_transcripts" headerClasses="justify-content-center" :show-close="true">
        <h5 slot="header" class="title title-up">Transcripts</h5>
        <div class="row">
                <el-table class=""
                          ref="Transcripts"
                          :data="transcripts"
                          border
                          highlight-current-row
                          @current-change=""
                          style="width: 100%"
                          size="medium"
                          :row-class-name="tableRowClassName"
                          >
                  <el-table-column v-for="column in tableColumns_transcripts"
                                  :key="column.label"
                                  :min-width="column.minWidth"
                                  :prop="column.prop"
                                  :label="column.label"
                                  :align="column.align"
                                  :sortable="column.sortable"
                                  >
                  </el-table-column>

                </el-table>
        </div>

      </modal>


    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import moment from 'moment';
  import {Table, TableColumn, Select, Option, Tabs, TabPane, Slider, Input, InputNumber, Tag, Popover, Switch, Tooltip, Button, ButtonGroup, Col, Row } from 'element-ui';
  // import Button from 'src/components/UIComponents/Button';
  import PPagination from 'src/components/UIComponents/Pagination.vue';
  import Loading from 'src/components/Layout/LoadingMainPanel.vue';
  import Modal from 'src/components/UIComponents/Modal'

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import axios from 'axios';
  import VueUploadComponent from 'vue-upload-component';
  Vue.component('file-upload', VueUploadComponent);

  Vue.use(Table);
  Vue.use(TableColumn);
  Vue.use(Tabs);
  Vue.use(Select);
  Vue.use(Option);
  Vue.use(Slider);
  Vue.use(InputNumber);

  export default {
    name: 'vars',
    props: {
    },    
    components: {
      PPagination,
      [Tabs.name]: Tabs,
      [TabPane.name]: TabPane,
      [Option.name]: Option,
      [Select.name]: Select,
      [Input.name]: Input,
      [Tag.name]: Tag,
      [Popover.name]: Popover,
      [Switch.name]: Switch,
      [Tooltip.name]: Tooltip,
      [Button.name]: Button,
      [ButtonGroup.name]: ButtonGroup,
      [Col.name]: Col,
      [Row.name]: Row,
      Modal,

    },


    data () {
      return {
        formdata_np: {
          name: "",
          np_id_workflow: "",
          created_dt: "",
          created_wh: "",

        },

        formdata_change_class: {
          id_var: 0,
          class_value: 0,
          description: "",
        },
        classes: [7,6,5,4,3,2,1],

        blackbox: "",
        files: [],

        searchQuery_hpo: "",

        slider_marks: {
          0: '0',
          10: '10',
          20: '20',
          30: '30',
          40: '40',
          50: '50',
          60: '60',
          70: '70',
          80: '80',
          90: '90',
          100: '100',
        },

        slider_marks_5: {
          1: '1',
          2: '2',
          3: '3',
          4: '4',
          5: '5',
        },

        slider_marks_10: {
          0: '0',
          0.1: '.1',
          0.2: '.2',
          0.3: '.3',
          0.4: '.4',
          0.5: '.5',
          0.6: '.6',
          0.7: '.7',
          0.8: '.8',
          0.9: '.9',
          1: '1',          
        },

        var_order_options: [
          {
            value: 1,
            label: 'Clinvar DESC'
          }, 
          {
            value: 3,
            label: 'Internal Class DESC'
          }, 
          {
            value: 99,
            label: 'id_var'
          },           
        ],
        var_order: 1,

        interpret_id_var: 0,
        interpret_value: 0,

        selects: {
          simple: '',
          multiple: 'ARS'
        },

        l_gt: ["0/1", "1/1"],
        l_impacts: ["LOW", "HIGH", "MODERATE", "MODIFIER"],


        pagination_v: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100],
          total: 0
        },

        tableColumns_v: [
          {
            prop: 'chrom',
            label: 'Chr',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
        ],

        tableColumns_v1: [
          {
            prop: 'dp',
            label: 'Depth',
            minWidth: 70,
            align: "center",
            sortable: false,
          },
          {
            prop: 'freq',
            label: 'Freq',
            minWidth: 50,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_22',
            label: 'Type',
            minWidth: 75,
            align: "center",
            sortable: false,
          },

        ],

        tableColumns_v2: [
          {
            prop: 'a_3',
            label: 'Impact',
            minWidth: 95,
            align: "center",
            sortable: false,
          },

        ],

        tableColumns_v3: [
          {
            prop: 'a_9',
            label: 'Exon',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_10',
            label: 'Intron',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
        ],

        tableColumns_v3a: [
          {
            prop: 'a_35',
            label: 'GnomAD AF',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_41',
            label: 'GnomAD EU',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
        ],

        tableColumns_v4: [
          {
            prop: 'id_var',
            label: 'ID',
            minWidth: 100,
            align: "center",
            sortable: false,
            hasChildren: true
          },
        ],

        pagination_ff: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50, 100],
          total: 0
        },

        tableColumns_ff: [
          {
            prop: 'id_filter',
            label: 'ID',
            minWidth: 60,
            align: "right",
            sortable: false,
          },
          {
            prop: 'name',
            label: 'NAME',
            minWidth: 100,
            align: "left",
            sortable: false,
          },
          {
            prop: 'short_text',
            label: 'SHORT',
            minWidth: 100,
            align: "left",
            sortable: false,
          },
          {
            prop: 'status',
            label: 'S.',
            minWidth: 40,
            align: "center",
            sortable: false,
          },
          {
            prop: 'made',
            label: 'MADE',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'description',
            label: 'DESC.',
            minWidth: 200,
            align: "left",
            sortable: false,
          },

        ],

        pagination_hpo: {
          perPage: 5,
          currentPage: 1,
          perPageOptions: [5,10],
          total: 0
        },


        tableColumns_transcripts: [
          {
            prop: 'a_7',
            label: 'Feature',
            minWidth: 130,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_11',
            label: 'HGVSc',
            minWidth: 120,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_12',
            label: 'HGVSp',
            minWidth: 120,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_9',
            label: 'Exon',
            minWidth: 60,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_10',
            label: 'Intron',
            minWidth: 60,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_3',
            label: 'Impact',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_2',
            label: 'Conseq',
            minWidth: 160,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_13',
            label: 'cDNA',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_14',
            label: 'CDS',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_15',
            label: 'Protein',
            minWidth: 100,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_16',
            label: 'Amino acids',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_17',
            label: 'Codons',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'a_19',
            label: 'Distance',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
          {
            prop: 'er',
            label: 'ER',
            minWidth: 80,
            align: "center",
            sortable: false,
          },
        ],

      }
    },

    computed: {
      ...mapState({
        vars: state => state.vars,
        f_filters: state => state.f_filters,
        u_filters: state => state.u_filters,
        hpo: state => state.hpo,
        l_gene: state => state.l_gene,
        l_consequences: state => state.l_consequences,
        l_features: state => state.l_features,
        l_clinvars: state => state.l_clinvars,
        l_clinvar_dns: state => state.l_clinvar_dns,
        d_a_cols: state => state.d_a_cols,

        cufi: state => state.cufi,
        id_examination: state => state.id_examination,

        vars_order: state => state.vars_order,

        pan_new_project: state => state.pan_new_project,
        pan_project: state => state.pan_project,

        transcripts: state => state.transcripts,

        user: state => state.user
      }),

      ...mapGetters({
        g_gene: 'g_gene',
        g_examination: 'g_examination',

        }),

      pagedData_v () {
        return this.vars.slice(this.from_v, this.to_v)
      },

      vars_data () {
        if (!this.searchQuery_v) {
          this.pagination_v.total = this.vars.length
          return this.pagedData_v
        }
        let result = this.vars
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_v) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_v)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_v.total = result.length
        return result.slice(this.from_v, this.to_v)
      },

      to_v () {
        let highBound = this.from_v + this.pagination_v.perPage
        if (this.total_v < highBound) {
          highBound = this.total_v
        }
        return highBound
      },

      from_v () {
        return this.pagination_v.perPage * (this.pagination_v.currentPage - 1)
      },

      total_v () {
        this.pagination_v.total = this.vars.length
        return this.vars.length
      },


      pagedData_ff () {
        return this.f_filters.slice(this.from_ff, this.to_ff)
      },

      f_filters_data () {
        if (!this.searchQuery_ff) {
          this.pagination_ff.total = this.f_filters.length
          return this.pagedData_ff
        }
        let result = this.f_filters
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch_ff) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery_ff)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination_ff.total = result.length
        return result.slice(this.from_ff, this.to_ff)
      },

      to_ff () {
        let highBound = this.from_ff + this.pagination_ff.perPage
        if (this.total_ff < highBound) {
          highBound = this.total_ff
        }
        return highBound
      },

      from_ff () {
        return this.pagination_ff.perPage * (this.pagination_ff.currentPage - 1)
      },

      total_ff () {
        this.pagination_ff.total = this.f_filters.length
        return this.f_filters.length
      },

      pagedData_hpo () {
        return this.hpo.slice(this.from_hpo, this.to_hpo)
      },

      hpo_data () {
        if (!this.searchQuery_hpo) {
          this.pagination_hpo.total = this.hpo.length
          return this.pagedData_hpo
        }
        let result = this.hpo
          .filter((row) => {
            let isIncluded = false
            let rowValue = row["hpo_term_name"].toString()
            if (rowValue.includes && rowValue.includes(this.searchQuery_hpo)) {
              isIncluded = true
            }
            return isIncluded
          })
        this.pagination_hpo.total = result.length
        return result.slice(this.from_hpo, this.to_hpo)
      },

      to_hpo () {
        let highBound = this.from_hpo + this.pagination_hpo.perPage
        if (this.total_hpo < highBound) {
          highBound = this.total_hpo
        }
        return highBound
      },

      from_hpo () {
        return this.pagination_hpo.perPage * (this.pagination_hpo.currentPage - 1)
      },

      total_hpo () {
        this.pagination_hpo.total = this.hpo.length
        return this.hpo.length
      },


      slider_value: {
        get () {
          return this.$store.state.slider_value;
        },
        set (value) {
          this.$store.commit('m_slider_value', value);
        }
      },

      cufi_read_depth: {
        get () {
          return this.$store.state.cufi.read_depth;
        },
        set (value) {
          let mykey = "read_depth";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_freq_vcf: {
        get () {
          return this.$store.state.cufi.freq_vcf;
        },
        set (value) {
          let mykey = "freq_vcf";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_genotype: {
        get () {
          return this.$store.state.cufi.genotype;
        },
        set (value) {
          let mykey = "genotype";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_freq_project: {
        get () {
          return this.$store.state.cufi.freq_project;
        },
        set (value) {
          let mykey = "freq_project";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_freq_subject: {
        get () {
          return this.$store.state.cufi.freq_subject;
        },
        set (value) {
          let mykey = "freq_subject";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_freq_global: {
        get () {
          return this.$store.state.cufi.freq_global;
        },
        set (value) {
          let mykey = "freq_global";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_impacts: {
        get () {
          return this.$store.state.cufi.impacts;
        },
        set (value) {
          let mykey = "impacts";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_consequences: {
        get () {
          return this.$store.state.cufi.consequences;
        },
        set (value) {
          let mykey = "consequences";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_clinvar: {
        get () {
          return this.$store.state.cufi.clinvar;
        },
        set (value) {
          let mykey = "clinvar";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_clinvar_dn: {
        get () {
          return this.$store.state.cufi.clinvar_dn;
        },
        set (value) {
          let mykey = "clinvar_dn";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_interpret_subject: {
        get () {
          return this.$store.state.cufi.interpret_subject;
        },
        set (value) {
          let mykey = "interpret_subject";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_interpret_all: {
        get () {
          return this.$store.state.cufi.interpret_all;
        },
        set (value) {
          let mykey = "interpret_all";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_gnomad_af: {
        get () {
          return this.$store.state.cufi.gnomad_af;
        },
        set (value) {
          let mykey = "gnomad_af";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_gnomad_af_nfe: {
        get () {
          return this.$store.state.cufi.gnomad_af_nfe;
        },
        set (value) {
          let mykey = "gnomad_af_nfe";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_exac_af_nfe: {
        get () {
          return this.$store.state.cufi.exac_af_nfe;
        },
        set (value) {
          let mykey = "exac_af_nfe";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_genes: {
        get () {
          return this.$store.state.cufi.genes;
        },
        set (value) {
          let mykey = "genes";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_wois_switch: {
        get () {
          return this.$store.state.cufi.wois_switch;
        },
        set (value) {
          let mykey = "wois_switch";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },

      cufi_woia_switch: {
        get () {
          return this.$store.state.cufi.woia_switch;
        },
        set (value) {
          let mykey = "woia_switch";
          this.$store.commit('m_cufi', {mykey, value});
        }
      },



      filter_name: {
        get () {
          return this.$store.state.ff_name;
        },
        set (value) {
          this.$store.commit('m_ff_name', value);
        }
      },

      filter_description: {
        get () {
          return this.$store.state.ff_description;
        },
        set (value) {
          this.$store.commit('m_ff_description', value);
        }
      },

      er_switch: {
        get () {
          return this.$store.state.er_switch;
        },
        set (value) {
          this.$store.commit('m_er_switch', value);
        }
      },

      var_page: {
        get () {
          return this.$store.state.var_page;
        },
        set (value) {
          this.$store.commit('m_var_page', value);
        }
      },

      modal_interpretation: {
        get () {
          return this.$store.state.modal_interpretation;
        },
        set (value) {
          this.$store.commit('m_modal_interpretation', value);
        }
      },

      modal_transcripts: {
        get () {
          return this.$store.state.modal_transcripts;
        },
        set (value) {
          this.$store.commit('m_modal_transcripts', value);
        }
      },

    },


    methods: {
      handle_unavailable (index, row, event) {
        event.stopImmediatePropagation();
        alert(`Not available in trial version.`)
      },

      handleEdit (index, row) {
        alert(`Your want to edit ${row.name}`)
      },

      handleDelete (index, row) {
        let indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id)
        if (indexToDelete >= 0) {
          this.tableData.splice(indexToDelete, 1)
        }
      },

      tableRowClassName({row, rowIndex}) {
        if (row.er === 1) {
          return 'success-row';
        } else if (row.er === -1) {
          return 'danger-row';
        } else {
          return 'row_0';
        }
      },

      submit_np() {
        console.log(this.formdata_np);
        
      },

      handle_transcripts( index, row, event ) {
        event.stopImmediatePropagation();
        this.m_transcripts([]);
        this.m_modal_transcripts(true);
        this.a_anots( {"id_var": row.id_var, "er": this.er_switch } );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // console.log(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // resolve(this.a_anots( {"id_var": tree.id_var, "er": this.cufi.er_switch } ) );
        // let mypayload = { "id_var": tree.id_var, "er": this.cufi.er_switch };


      },


      submit_formdata_change_class() {
        this.a_change_interpretation( this.formdata_change_class );
        this.a_vars( {"order": this.vars_order, "er_switch": this.er_switch, "cufi": this.cufi, "id_examination": this.id_examination} );
        this.a_notify("Interpretation was changed.");
      },
      
      show_slider_value() {
        console.log(this.slider_value);
        this.a_notify("Genes were added to Custom Filter");
      },

      change_var_page() {
        console.log(this.var_page);
        
      },

      order_select_change(value) {
        this.m_vars_order(value);
        this.a_vars( {"order": value, "er_switch": this.er_switch, "cufi": this.cufi, "id_examination": this.id_examination} );
      },


      show_tab_click(tab, event){
        console.log(tab.index);
        
      },

      add_project(){
        console.log("NP!");
        this.m_pan_new_project(true);
        this.m_id_project(0);
      },

      show_click(value){
        console.log(value);
      },

      select_filter_gene(value){
        console.log(value);
        this.m_ss_gene(value);
      },

      select_filter(value){
        console.log(value);
      },

      // select_impact(value){
      //   console.log(value);
      //   this.m_cufi_impacts(value);
      // },

      reset_filter(){
        this.m_cufi_default();
      },

      show_vars(){
        this.a_vars( {"order": this.vars_order, "er_switch": this.er_switch, "cufi": this.cufi, "id_examination": this.id_examination} );
      },

      show_all_vars(){
        this.a_vars( {"order": this.vars_order, "er_switch": this.er_switch, "id_examination": this.id_examination} );
      },

      cufi_genes_del(){
          let mykey = "genes";
          let value = [];
          this.$store.commit('m_cufi', {mykey, value});
      },
    
      mylink_symbol(myvar) {
        return "https://www.genecards.org/cgi-bin/carddisp.pl?gene=" + myvar ;
      },

      mylink_clinsig(row) {
        return "http://www.ncbi.nlm.nih.gov/clinvar/?term=" + row.a_450 + "[alleleid]" ;
      },

      mylink_dbsnp(one) {
        return "http://www.ncbi.nlm.nih.gov/snp/" + one ;
      },

      mylink_pos(row) {
        return "http://www.ensembl.org/Homo_sapiens/Location/View?r=" + (row.chrom).substring(3) + ":" + row.pos + "-" + row.pos ;
      },

      mylink_hgvsc(row) {
        return "http://genome.ucsc.edu/cgi-bin/hgTracks?db=hg38&position=" + row.a_11_full + "&hgt.out3=submit" ;
      },

      mylink_transcript(row) {
        return "https://www.ncbi.nlm.nih.gov/nuccore/" + row.a_7 ;
      },

      mylink_cosmic(row) {
        return "https://cancer.sanger.ac.uk/cosmic/search?q=" + row.a_445 ;
      },

      alertuj(mytext) {
        if (mytext === 1) {
          alert(mytext + " - Benign");
        } else if (mytext === 2) {
          alert(mytext + " - Likely benign");
        } else if (mytext === 3) {
          alert(mytext + " - Uncertain significance");
        } else if (mytext === 4) {
          alert(mytext + " - Likely pathogenic");
        } else if (mytext === 5) {
          alert(mytext + " - Pathogenic");
        } else {
          alert(mytext);
        }
      },

      x_modal_interpretation ( id_var, myvalue ) {
        this.formdata_change_class.id_var = id_var;
        this.formdata_change_class.class_value = myvalue;
        this.formdata_change_class.description = "";
        this.m_modal_interpretation(true);
      },

      popover_items ( mydata ) {
        let myitems = []
        for (let i of mydata.split(',')) {
          myitems.push( i.replace(/_/g, " ") );
        }
        return "<ul><li>" + myitems.join("</li><li>") + "</li></ul>";
      },

      ...mapMutations({
        m_slider_value: 'm_slider_value',
        m_er_switch: 'm_er_switch',
        m_var_page: 'm_var_page',
        m_ss_gene: 'm_ss_gene',
        m_vars: 'm_vars',
        m_vars_order: 'm_vars_order',
        m_id_examination: 'm_id_examination',

        m_modal_interpretation: 'm_modal_interpretation',
        m_modal_transcripts: 'm_modal_transcripts',
        m_transcripts: 'm_transcripts',
        m_cufi_default: 'm_cufi_default',

      }),


      ...mapActions({
        a_varsall: 'a_varsall',
        a_vars: 'a_vars',
        a_f_filters: 'a_f_filters',
        a_filter_save: 'a_filter_save',
        a_change_interpretation: 'a_change_interpretation',
        a_anots: 'a_anots',
        a_notify: 'a_notify',

        }),

      // setCurrent(row) {
      //   this.$refs.singleTable.setCurrentRow(row);
      // },
      // handleCurrentChange_p(val) {
      //   if (val && val.id_project > 0) {
      //     this.m_id_project(val.id_project);
      //     this.m_id_examination(0);
      //     this.m_pan_project(true);
      //     // this.a_examinations(val.id_project);
      //     this.project_name = val.name;
      //   } else {
      //     this.m_id_project(0);
      //     this.m_id_examination(0);
      //     this.m_pan_project(false);
      //     this.project_name = "";
      //   }
      // },

      // handleCurrentChange_e(val) {
      //   if (val && val.id_examination > 0) {
      //     this.m_id_examination(val.id_examination);
      //     this.a_vars( {"order": 1, "id_examination": val.id_examination} );
      //   } else {
      //     this.m_id_examination(0);
      //   }
      // },

      handleCurrentChange_v(val) {
        if (val && val.id_var > 0) {
          // this.a_examinations(val.id_examination);
        } else {
          // this.m_i_examination(0);
        }
      },

      handleCurrentChange_ff(val) {
        if (val && val.id_filter > 0) {
          console.log(val);
          // this.a_examinations(val.id_examination);
        } else {
          console.log(val);
          // this.m_i_examination(0);
        }
      },

      handleCurrentChange_hpo(val) {
        if (val) {
          let skuplek = [];
          for (let a of this.cufi.genes.values()) {
            skuplek.push(a);
          }
          for (let s of val.genelist) {
            if (!(skuplek.includes(s))) {
              skuplek.push(s);
            }
          }
          skuplek.sort();
          let mykey = "genes";
          let value = skuplek;
          this.$store.commit('m_cufi', {mykey, value});
        }
        this.a_notify("Genes were added to Custom Filter");

      },

      inputFile: function (newFile, oldFile) {
        if (newFile && !newFile.active) {
          // Get response data
          console.log('response', newFile.response)
          if (newFile.xhr) {
            //  Get the response status code
            console.log('status', newFile.xhr.status)
          }
        }
      },


    },

    beforeMount () {
      // this.a_vars();
      this.m_vars([]);
      moment.locale("us");
      this.formdata_np.created_dt = moment(Date().toLocaleString()).format('LLL');
      this.a_f_filters();
    },


 
    afterDestroy () {
      this.m_vars([]);
    },


  }
</script>
<style lang="scss">
  .el-table .td-actions{
    button.btn {
      margin-right: 5px;
    }
  }

  .el-table {
    font-size: 12px !important;
  }

  .el-table .cell{
    line-height: 20px !important;
    word-break: break-word !important;
  }

  .el-table td, .el-table th {
    padding: 3px 0 !important;
  }

  .el-table .row_0 {
    background: rgb(253, 253, 253) !important;
  }

  .el-table .row_1 {
    background: rgb(243, 245, 152) !important;
  }

  .el-table .row_2 {
    background: rgb(248, 221, 171) !important;
  }

  .el-table .row_3 {
    background: rgb(248, 186, 157) !important;
  }

  .el-table .row_4 {
    background: rgb(197, 248, 208) !important;
  }

  .el-table .row_9 {
    background: rgb(250, 197, 184) !important;
  }



  .el-table .warning-row {
    background: rgb(241, 175, 52) !important;
  }

  .el-table .success-row {
    background: #0ada14 !important;
  }

  .el-table .danger-row {
    background: #f34c19 !important;
  }

  .el-table .info-row .el-tabs--border-card {
    background: #8fbdf1 !important;
  }

  .hranaty {
    border-radius: 2px !important;
  }

  h4 {
    margin-top: 5px !important;
  }

  .dolu {
    padding-top: 80px !important;
  }

  .table > thead > tr > th, .el-table table > thead > tr > th {
    font-size: 12px !important;
  }

  .mezera {
    margin-right: 10px;
  }

  .bottom_margin_30 {
    margin-bottom: 30px;
  }

  .bottom_margin_10 {
    margin-bottom: 10px;
  }

  .top_margin_10 {
    margin-top: 10px;
  }

  .top_margin_30 {
    margin-top: 30px;
  }

  .top_margin_50 {
    margin-top: 50px;
  }

  .bg_gray {
    background: #e2e4e5 !important;
  }

  .bg_white {
    background-color: #FFF !important;
  }

  .gene_blue {
    background-color: #024e74 !important;
    margin-left: 0px !important;
    border-radius: 6px !important;
  }

  .el-tag {
      border-radius: 2px !important;
      margin-left: 3px !important;
      margin-bottom: 3px !important;
  }

  .bg_white_tab {
    background-color: #FFF !important;
    z-index: 9999 !important;
  }

  .el-row {
    margin-bottom: 10px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #eee;
    min-height: 12px;
    padding-left: 4px !important;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 18px;
  }

  .row-bg {
    padding: 3px 0;
    background-color: #f9fafc;
  }
  .el-table .cell {
      word-break: break-word;
  }

  .small_label {
      font-size: 10px !important;
      padding-top: 2px !important;
      padding-right: 4px !important;
  }

  .min_height {
    border-radius: 4px;
    height: 30px !important;
  }

  .popover_bg {
    background: #a3bbf1;
  }


</style>
